import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const TableContainer = styled.div`
  margin: 16px 0;
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: ${Tokens.RadiusInput};
  overflow: hidden;
  background-color: ${Tokens.ColorWhite};
`

export const TableHeader = styled.thead`
  background-color: ${Tokens.ColorBackground};
  border-bottom: 1px solid ${Tokens.ColorBorder};
`

export const TableBody = styled.tbody``

export const TableRow = styled.tr<{ $isGroupRow?: boolean }>`
  border-bottom: 1px solid ${Tokens.ColorBorder};

  &:last-child {
    border-bottom: none;
  }

  ${({ $isGroupRow }) =>
    $isGroupRow === true &&
    `
    background-color: #f7f8fa;
  `}

  ${({ $isGroupRow }) =>
    $isGroupRow === false &&
    `
    background-color: ${Tokens.ColorWhite};
  `}
`

export const TableCell = styled.td<{
  $width?: number
  $align?: 'left' | 'center' | 'right'
  $isHeader?: boolean
}>`
  padding: ${({ $isHeader }) => ($isHeader ? '12px 16px' : '8px 16px')};
  text-align: ${({ $align }) => $align || 'left'};
  vertical-align: middle;

  ${({ $width }) =>
    $width &&
    `
    width: ${$width}px;
    min-width: ${$width}px;
  `}

  font-size: 14px;
  color: ${({ $isHeader }) => ($isHeader ? Tokens.ColorTextSecondary : Tokens.ColorTextPrimary)};
  font-weight: ${({ $isHeader }) => ($isHeader ? '600' : '400')};
`

export const TableInputContainer = styled.div`
  width: 80px;

  .input-container {
    width: 100%;
    gap: 0;

    label {
      display: none;
    }
  }

  .input-container > div {
    height: 32px;
    padding: 0 8px;
    border: 1px solid ${Tokens.ColorBorder};
    border-radius: ${Tokens.RadiusInput};
    background-color: ${Tokens.ColorBackground};
    transition: all 0.2s ease;

    &:hover {
      background-color: ${Tokens.ColorHover};
      border-color: ${Tokens.ColorUIPrimary};
    }

    &:focus-within {
      background-color: ${Tokens.ColorWhite};
      border-color: ${Tokens.ColorUIPrimary};
      box-shadow: 0 0 0 2px rgba(1, 195, 141, 0.1);
    }
  }

  .input-container input {
    font-size: 12px;
    text-align: center;
    min-width: 50px;
    color: ${Tokens.ColorTextPrimary};
    background: transparent;

    &::placeholder {
      color: ${Tokens.ColorTextTertiary};
    }

    &:focus {
      outline: none;
    }
  }
`
